export default __webpack_public_path__ + "static/media/hombre.88577bef.png";